/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Property_HeaderInputs */



/**
* | output |
* | --- |
* | "Property" |
*
* @param {Explorer_Info_Property_HeaderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_property_header = /** @type {((inputs?: Explorer_Info_Property_HeaderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Property_HeaderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriete")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigentum")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietà")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Свойство")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedad")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("财产")
	if (locale === "ja") return /** @type {LocalizedString} */ ("財産")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संपत्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedade")
	return /** @type {LocalizedString} */ ("Property")
});